import { lg } from '@variables/mediaQueries';
//import PersonalizationTests from '@type/inline/PersonalizationTests';
import AsyncAlpine from 'async-alpine';
import Alpine from 'alpinejs';
import { themePath } from '@variables/theme';
import focus from '@alpinejs/focus';
import { setCookie, getCookie } from 'typescript-cookie';
import User from '@type/inline/User';
import loadForm from '@functions/loadForm/loadForm';
import Swiper from 'swiper';
import { Pagination, Navigation, EffectCreative } from 'swiper/modules';

//declare let personalizationTests: PersonalizationTests;

declare const user: User;

declare global {
    interface Window {
        /*CRO Test: Time Selection, May 27th,2025 */
        activateSelectonTest: () => void;
        /*End CRO Test*/
    }
}

//Disables persona peprsonalization modal on window.environments that aren't production, because it's annoying
// if (window['environment']['name'] !== 'production' && window['environment']['name'] !== 'development') {
//     setCookie('persona', 'none', { expires: 60, sameSite: 'lax', path: '/' });
// }

// if (window['environment']['name'] === 'local') {
//     setCookie('persona', 'supportseekerpersona', { expires: 60, sameSite: 'lax', path: '/' });
// }

//Dynamic Form Initialization
document.addEventListener('DOMContentLoaded', () => {
    const formMounts = document.querySelectorAll('[data-tb-form-id]');
    if (formMounts.length >= 1) {
        formMounts.forEach(async (mount) => {
            if (mount instanceof HTMLElement) {
                try {
                    await loadForm(mount.dataset.tbFormId);
                } catch (error) {
                    console.error(error);
                }
            }
        });
    }
});

//Constant values
const headerHeight = 97;

window.Alpine = Alpine;

Alpine.plugin(focus);

document.addEventListener('alpine:init', () => {
    Alpine.data('location', () => ({
        version: null,
        init() {
            this.version = user.location.country.name;
        },
    }));
});

Alpine.store('mobileMenu', {
    open: false,
    prevents: ['restaurant-types', 'dropdown'],
    currentSubMenuItem: null,
    currentSubSubMenuItem: null,
    toggle() {
        this.open = !this.open;
    },
    subMenuItem(e) {
        if (
            !!e.target.nextElementSibling &&
            this.prevents.some((classname) => e.target.nextElementSibling.classList.contains(classname))
        ) {
            e.preventDefault();
            if (this.currentSubMenuItem === e.target) {
                this.currentSubSubMenuItem = null;
            } else {
                this.currentSubMenuItem = e.target;
            }
        }
    },
    subSubMenuItem(e) {
        if (!!e.target.parentNode.classList.contains('on-mobile-hide-children')) {
            e.preventDefault();
            if (this.currentSubSubMenuItem === e.target) {
                this.currentSubSubMenuItem = null;
            } else {
                this.currentSubSubMenuItem = e.target;
            }
        }
    },
});

Alpine.store('mainMenu', {
    prevents: ['6327', 'restaurant-types', 'dropdown'],
    currentSubMenuItem: null,
    tabEnd: false,
    onInit(val) {
        this.currentSubMenuItem = val;
    },
    menuItem(e) {
        if (this.prevents.includes(e.target.id)) {
            e.preventDefault();
        }
    },
    onMenuItemHover(e) {
        if (e.target.dataset.name === 'products') {
            dataLayer.push({ event: 'optimize.productMenuVariant' });
            this.currentSubMenuItem = 'pos';
        }
    },
    onSubMenuHover(e) {
        this.currentSubMenuItem = e.target.dataset.name;
    },
    onSubMenuHoverOut(e) {
        this.currentSubMenuItem = e.target.dataset.name;
    },
});

Alpine.store('resizeEvents', {
    isMobile: lg.matches ? false : true,
    resizeCheck() {
        this.isMobile = lg.matches ? false : true;
    },
});

Alpine.store('scrollEvents', {
    scrolled: false,
    checkScroll() {
        if (window.scrollY > headerHeight) {
            this.scrolled = true;
        } else {
            this.scrolled = false;
        }
    },
});

Alpine.store('promoBanner', {
    enabled: window.bannerInfo.active && getCookie('promo_banner_dismissed') === undefined,
    close() {
        this.enabled = false;
        setCookie('promo_banner_dismissed', 'true', {
            expires: 60,
            sameSite: 'lax',
            path: '/',
        });
    },
});

/*CRO Test: Time Selection, May 27th,2025 */
type croTimeSelection = {
    enabled: boolean;
    setEnabled: () => void;
};
Alpine.store('croTimeSelection', {
    enabled: false,
    setEnabled() {
        this.enabled = true;
    },
} as croTimeSelection);
/*End CRO Test*/

Alpine.store('modalBookADemo', {
    loaded: false,
    bookADemoFunc: null,
    async init() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('book-a-demo-show') && urlParams.get('book-a-demo-show') === 'true' && !this.loaded) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const bookADemo = await import(`${window.location.origin}${themePath}/js/modal--book-a-demo.js`);
            this.bookADemoFunc = bookADemo.default;
            this.loaded = true;
            this.bookADemoFunc({});
        }
    },
    async openBookADemo() {
        if (!this.loaded) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const bookADemo = await import(`${window.location.origin}${themePath}/js/modal--book-a-demo.js`);
            this.bookADemoFunc = bookADemo.default;
            this.loaded = true;
        }
        this.bookADemoFunc(
            /*CRO Test: Time Selection, May 27th,2025 */
            {
                enableTimeSelection: (Alpine.store('croTimeSelection') as croTimeSelection).enabled,
            }
            /*End CRO Test */
        );
    },
    async bookADemoWithNumberOfLocations() {
        if (!this.loaded) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const bookADemo = await import(`${window.location.origin}${themePath}/js/modal--book-a-demo.js`);
            this.bookADemoFunc = bookADemo.default;
            this.loaded = true;
        }
        this.bookADemoFunc({
            enableLocationsField: true,
        });
    },
    async openBookADemoWithCID(e) {
        if (!this.loaded) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const bookADemo = await import(`${window.location.origin}${themePath}/js/modal--book-a-demo.js`);
            this.bookADemoFunc = bookADemo.default;
            this.loaded = true;
        }
        this.bookADemoFunc(
            /*CRO Test: Time Selection, May 27th,2025 */
            {
                enableTimeSelection: (Alpine.store('croTimeSelection') as croTimeSelection).enabled,
            }
            /*End CRO Test */
        );
        window.formInfo.cid = e.target.dataset.cid;
    },
    async bookADemoWithRequestAQuoteTitle() {
        if (!this.loaded) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const bookADemo = await import(`${window.location.origin}${themePath}/js/modal--book-a-demo.js`);
            this.bookADemoFunc = bookADemo.default;
            this.loaded = true;
        }
        window.formInfo.ss = 'I - Request Quote';
        this.bookADemoFunc({
            descriptionTitle: 'Request a Quote',
            descriptionText: 'Tell us about yourself below to request a quote.',
            /*CRO Test: Time Selection, May 27th,2025 */
            enableTimeSelection: (Alpine.store('croTimeSelection') as croTimeSelection).enabled,
            /*End CRO Test */
        });
    },
    async bookADemoWithRequestAQuoteTitleWithNumberOfLocations() {
        if (!this.loaded) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const bookADemo = await import(`${window.location.origin}${themePath}/js/modal--book-a-demo.js`);
            this.bookADemoFunc = bookADemo.default;
            this.loaded = true;
        }
        window.formInfo.ss = 'I - Request Quote';
        this.bookADemoFunc({
            descriptionTitle: 'Request a Quote',
            descriptionText: 'Tell us about yourself below to request a quote.',
            enableLocationsField: true,
        });
    },
    async openBookADemoWithRequestAQuoteTitleWithCID(e) {
        if (!this.loaded) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const bookADemo = await import(`${window.location.origin}${themePath}/js/modal--book-a-demo.js`);
            this.bookADemoFunc = bookADemo.default;
            this.loaded = true;
        }
        window.formInfo.ss = 'I - Request Quote';
        window.formInfo.cid = e.target.dataset.cid;
        this.bookADemoFunc({
            descriptionTitle: 'Request a Quote',
            descriptionText: 'Tell us about yourself below to request a quote.',
            /*CRO Test: Time Selection, May 27th,2025 */
            enableTimeSelection: (Alpine.store('croTimeSelection') as croTimeSelection).enabled,
            /*End CRO Test */
        });
    },
    async bookADemoWithContactSalesTitle() {
        if (!this.loaded) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const bookADemo = await import(`${window.location.origin}${themePath}/js/modal--book-a-demo.js`);
            this.bookADemoFunc = bookADemo.default;
            this.loaded = true;
        }
        window.formInfo.ss = 'I - Request Quote';
        this.bookADemoFunc({
            descriptionTitle: 'Contact Sales',
            descriptionText: 'Let’s talk about how our solutions can benefit your business.',
        });
    },
    /*CRO Test: Time Selection, May 27th,2025 */
    async bookADemoTimeSelection() {
        if (!this.loaded) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const bookADemo = await import(`${window.location.origin}${themePath}/js/modal--book-a-demo.js`);
            this.bookADemoFunc = bookADemo.default;
            this.loaded = true;
        }
        window.formInfo.ss = 'I - Request Quote';
        this.bookADemoFunc({
            enableTimeSelection: true,
        });
    },
    /*End CRO Test*/
});

/*CRO Test: Widget Form Reprirse (Novm 2024) */

export type croWidgetFormTest = {
    enabled: boolean;
    setEnabled: () => void;
};
Alpine.store('croWidgetFormTest', {
    enabled: false,
    setEnabled() {
        this.enabled = true;
    },
} as croWidgetFormTest);
/*End CRO Test*/

Alpine.plugin(AsyncAlpine);

// @ts-expect-error Async Alpine does not provide types (yet)
Alpine.asyncData(
    'modal__request_a_quote',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    () => import(`${window.location.origin}${themePath}/js/alpine.modal--request-a-quote.js`)
);
// @ts-expect-error Async Alpine does not provide types (yet)
Alpine.asyncData(
    'productGuide',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    () => import(`${window.location.origin}${themePath}/js/alpine.product-guide.js`)
);
// @ts-expect-error Async Alpine does not provide types (yet)
Alpine.asyncData(
    'customerHub',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    () => import(`${window.location.origin}${themePath}/js/alpine.customer-hub.js`)
);
Alpine.start();

/*CRO Test: Time Selection, May 27th,2025 */
const activateSelectonTest = () => {
    (Alpine.store('croTimeSelection') as croTimeSelection).setEnabled();
};

window.activateSelectonTest = activateSelectonTest;
/*End CRO Test */

const testimonialCarousel = document.getElementById('testimonial-carousel') as HTMLDivElement;

if (testimonialCarousel) {
    new Swiper('#testimonial-carousel', {
        modules: [Pagination, Navigation, EffectCreative],
        slidesPerView: 1,
        effect: 'creative',
        simulateTouch: true,
        watchSlidesProgress: true,
        creativeEffect: {
            prev: {
                translate: [0, 0, -400],
            },
            next: {
                translate: ['100%', 0, 0],
            },
        },
        navigation: {
            prevEl: '.testimonial-carousel-prev',
            nextEl: '.testimonial-carousel-next',
        },
        breakpoints: {
            767: {
                simulateTouch: false,
            },
        },
    });
}

/* HOTFIX/DEBT: Someone forgot how to do the attribution properly,
so we're just going to force a Lead Source value change on load */
function bekCampaign() {
    const urlParams = new URLSearchParams(window.location.search);
    const campaignParam = urlParams.get('utm_campaign');

    return campaignParam === 'organic_social_bek_decembercampaign_bookademo';
}
document.addEventListener('DOMContentLoaded', () => {
    if (bekCampaign()) {
        window.formInfo.ls = '16. Partner';
    }
});
/* END HOTFIX/DEBT */
